// i18n area 'hci' — locale de-DE (task #171, onda 1): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/hci.de-DE.meta.json.
import type { enUS } from './hci'

export const deDE: typeof enUS = {
  hci: {
    ceph: {
      title: 'Ceph-Cluster',
      createButton: 'Ceph-Cluster erstellen',
      emptyTitle: 'Kein verwalteter Ceph-Cluster',
      emptyBody: 'TVirt verteilt und besitzt Ceph auf den Mitgliedsknoten, hyperkonvergent mit der VM-Last. Erstellen Sie einen Cluster: der erste Monitor und sein Manager entstehen automatisch auf dem gewählten Kontrollknoten — danach wächst er mit weiteren Monitoren und OSD-Geräten.',
      pageTitle: 'Ceph-Cluster',
      colState: 'Status',
      colMembers: 'Mitglieder',
      colSize: 'Größe',
      colVersion: 'Ceph-Version',
      sizeCell: '{used} GiB belegt von {total} GiB gesamt',
      phase: {
        'not-deployed': 'Nicht deployt',
        deploying: 'Deploy läuft',
        healthy: 'Gesund',
        degraded: 'Degradiert',
        error: 'Fehler',
        destroying: 'Wird zerstört',
        destroyed: 'Zerstört'
      },
      health: {
        HEALTH_OK: 'Gesund (HEALTH_OK)',
        HEALTH_WARN: 'Mit Warnungen (HEALTH_WARN)',
        HEALTH_ERR: 'Im Fehlerzustand (HEALTH_ERR)',
        unknown: 'Noch nicht beobachtet',
        observedAt: 'beobachtet {time}'
      },
      create: {
        title: 'Ceph-Cluster erstellen',
        info: 'Beim Erstellen eines neuen Ceph-Clusters wird der erste Knoten gewählt, auf dem die Rollen MON und MGR installiert werden. Außerdem ist anzugeben, welche Subnet der Ceph-Traffic nutzt: die Public-Subnet dient dem allgemeinen Netzwerkverkehr, während die Cluster-Subnet für die internen Replikate zwischen den OSDs verwendet wird; unterschiedliche Subnets sind nicht zwingend nötig.',
        controlNode: 'Kontrollknoten',
        controlNodeHint: 'Der Mitgliedsknoten, auf dem der erste MON + MGR entstehen.',
        publicSubnet: 'Public-Subnet',
        publicSubnetHint: 'Eine im IPAM registrierte Subnet — die public_network von Ceph. Nach der Erstellung unveränderlich.',
        clusterSubnet: 'Cluster-Subnet',
        clusterSubnetHint: 'Eine im IPAM registrierte Subnet — die cluster_network von Ceph (Replikation/Backfill).',
        noSubnets: 'Keine Subnet registriert — legen Sie sie zuerst im IPAM an',
        sameSubnet: 'Gleiche Subnet für Public- und Cluster-Traffic',
        sameSubnetHint: 'Angehakt = das Cluster-Netzwerk (Replikation/Backfill) fällt mit dem Public-Netzwerk zusammen. Nicht angehakt = wählen Sie seine eigene Subnet UND die Adresse des Kontrollknotens darin.',
        controlAddress: 'Adresse des Kontrollknotens',
        controlAddressHint: 'Eine Adresse, die das IPAM für den Knoten innerhalb der Public-Subnet kennt.',
        controlClusterAddress: 'Cluster-Adresse des Kontrollknotens',
        controlClusterAddressHint: 'Eine Adresse, die das IPAM für den Knoten innerhalb der Cluster-Subnet kennt.',
        noAddresses: 'Das IPAM kennt keine Adressen dieses Knotens innerhalb der gewählten Subnet',
        started: 'Cluster erstellt — der Bootstrap läuft als Makrotask weiter; die Phase aktualisiert sich von selbst',
        error: 'Der Cluster wurde abgelehnt'
      },
      detail: {
        actions: 'Verfügbare Aktionen',
        tabOverview: 'Übersicht',
        tabManagementNodes: 'MON & MGR',
        tabDisks: 'OSD',
        tabPools: 'Pools',
        tabObjects: 'Objekte',
        tabCrush: 'CRUSH Map',
        tabCephfs: 'CephFS',
        tabAdvanced: 'Erweitert',
        phase: 'Phase',
        checksTitle: 'Aktive Gesundheits-Checks',
        noChecks: 'Kein aktiver Gesundheits-Check',
        checkMuted: 'stummgeschaltet',
        summaryPools: 'Pools',
        summaryFilesystems: 'Filesysteme',
        nodesCard: 'Knoten',
        monHint: 'Ein MGR läuft kolokiert mit jedem MON. Drei MONs sind das empfohlene Quorum; ein Laborcluster startet mit einem. OSDs und MDS leben in ihren eigenen Tabs.',
        monHintSplit: 'MON und MGR sind auf diesem Cluster getrennt (Erweitert): jede Rolle ist eine eigene Membership pro Knoten. Drei MONs sind das empfohlene Quorum; mindestens ein MGR muss existieren.',
        noMons: 'Kein Monitor deklariert',
        addNode: 'Knoten hinzufügen',
        removeNode: 'Knoten entfernen',
        removeNodeFrom: 'Knoten {node} entfernen (sein MON und der kolokierte MGR)',
        roleMon: 'Rolle MON',
        roleMgr: 'Rolle MGR',
        roleNa: 'N/A',
        roleNotObserved: 'noch nicht beobachtet',
        monInQuorum: 'im Quorum',
        monOutQuorum: 'außerhalb des Quorums',
        mgrActive: 'aktiv',
        mgrStandby: 'standby',
        addRoleMon: 'Rolle MON hinzufügen',
        removeRoleMon: 'Rolle MON entfernen',
        addRoleMgr: 'Rolle MGR hinzufügen',
        removeRoleMgr: 'Rolle MGR entfernen',
        restartMon: 'MON-Dienst neu starten',
        restartMgr: 'MGR-Dienst neu starten',
        addMon: 'MON hinzufügen',
        removeMon: 'MON entfernen',
        removeMonFrom: 'Rolle MON von {node} entfernen',
        addMgr: 'MGR hinzufügen',
        removeMgr: 'MGR entfernen',
        removeMgrFrom: 'Rolle MGR von {node} entfernen',
        addMds: 'MDS hinzufügen',
        removeMds: 'MDS entfernen',
        removeMdsFrom: 'Rolle MDS von {node} entfernen',
        mdsSection: 'Metadata-Server (MDS)',
        noMds: 'Kein MDS deklariert — ein Filesystem braucht zuerst einen',
        mdsHint: 'Die MDS-Membership ist vom ersten Tag an eigenständig: ein Cluster ohne CephFS deklariert keine, ein Aktiver plus ein Standby bedienen ein Filesystem gut. Ceph wählt Aktive und Standbys unter den deklarierten Daemons.',
        mdsActiveFor: 'aktiv — {fs}',
        mdsNotObserved: 'noch nicht beobachtet',
        lastMdsGuard: 'Der letzte MDS lässt sich nicht entfernen, solange ein Filesystem existiert — entfernen Sie zuerst die Filesysteme',
        lastMonGuard: 'Der letzte MON lässt sich nicht entfernen — den Cluster zu zerstören ist der einzige Ausweg',
        lastMgrGuard: 'Der letzte MGR lässt sich nicht entfernen — ein verwalteter Cluster läuft nie ohne Manager',
        registerDevice: 'OSD hinzufügen',
        unregisterDevice: 'Deregistrieren',
        activeDeviceGuard: 'Aktiver OSD — er geht über den OSD-Lebenszyklus hinaus, nicht über das Register',
        colNode: 'Knoten',
        devicePhase: { registered: 'Registriert', active: 'Aktiv' },
        health: 'Gesundheit',
        state: 'Status',
        fsid: 'fsid',
        fsidPending: 'fehlt — versuchen Sie den Bootstrap erneut',
        version: 'Ceph-Version',
        publicNetwork: 'Public-Netzwerk',
        clusterNetwork: 'Cluster-Netzwerk',
        clusterNetworkCollapsed: '= public',
        noActions: 'In dieser Phase ist keine Aktion verfügbar',
        destroyedNote: 'Cluster zerstört — die Zeile wird in Kürze automatisch entfernt'
      },
      overview: {
        services: 'Dienste',
        ok: 'gesund',
        warning: 'warning',
        down: 'ausgefallen',
        pgTitle: 'Zustände der PGs',
        pgTotal: '{n} PGs gesamt',
        capacityTitle: 'Speicherplatz',
        ioTitle: 'Aktueller I/O',
        ioReadBw: 'Lesebandbreite',
        ioWriteBw: 'Schreibbandbreite',
        ioReadIops: 'Lese-IOPS',
        ioWriteIops: 'Schreib-IOPS',
        notObserved: 'noch nicht beobachtet'
      },
      osd: {
        colId: 'ID',
        colClass: 'Device-Class',
        colState: 'Status',
        colSize: 'Größe',
        colPgs: 'PGs',
        empty: 'Kein OSD — fügen Sie einen aus einer deklarierten Datenfestplatte hinzu',
        markIn: 'IN markieren',
        markOut: 'OUT markieren',
        scrub: 'Scrub ausführen',
        deepScrub: 'Tiefen-Scrub ausführen',
        restart: 'Dienst neu starten',
        details: 'Details',
        actionGuard: 'Nur auf einem aktiven OSD eines deployten Clusters',
        inTitle: 'OSD IN markieren',
        inBody: 'osd.{id} kehrt in die Datenverteilung zurück (ceph osd in): Ceph rebalanciert Daten auf ihn zurück.',
        outTitle: 'OSD OUT markieren',
        outBody: 'osd.{id} verlässt die Datenverteilung (ceph osd out): seine Daten werden anderswohin rebalanciert und die Redundanz ist REDUZIERT, solange der Backfill läuft. Jederzeit umkehrbar mit IN markieren.',
        scrubTitle: 'Scrub planen',
        scrubBody: 'Ein Scrub von osd.{id} wird geplant: der MON reiht ihn ein, und die Zustände der PGs der folgenden Sweeps erzählen das Ergebnis.',
        deepScrubTitle: 'Tiefen-Scrub planen',
        deepScrubBody: 'Ein Tiefen-Scrub von osd.{id} wird geplant: die Variante, die die Bytes verifiziert — schwerer auf dem I/O, gleiche Mechanik.',
        restartTitle: 'OSD-Dienst neu starten',
        restartBody: 'osd.{id} wird über die Supervision des Workers auf seinem Knoten gestoppt und neu gestartet.',
        started: 'Aktion gestartet — die Beobachtung aktualisiert sich von selbst',
        error: 'Die OSD-Aktion wurde abgelehnt'
      },
      osdDetail: {
        title: 'OSD-Details',
        tabGeneral: 'Allgemein',
        tabNetwork: 'Netzwerk',
        tabDevices: 'Geräte',
        version: 'Version',
        hostname: 'Hostname',
        dataPath: 'OSD-Datenpfad',
        objectStore: 'OSD Object Store',
        encrypted: 'Verschlüsselt',
        yes: 'Ja',
        no: 'Nein',
        memory: 'Speichernutzung (PSS)',
        pid: 'Process ID (PID)',
        front: 'Front-Adresse (Client & Monitor)',
        hbFront: 'Heartbeat-Front-Adresse',
        back: 'Back-Adresse (OSD)',
        hbBack: 'Heartbeat-Back-Adresse',
        colDevice: 'Device',
        colType: 'Typ',
        colPhysical: 'Physisches Device',
        colSize: 'Größe',
        volumeTitle: 'Volume-Details',
        creationTime: 'Erstellungsdatum',
        lvName: 'LV Name',
        lvPath: 'LV Path',
        lvUuid: 'LV UUID',
        vgName: 'VG Name',
        noDevices: 'Kein Device für diesen OSD beobachtet'
      },
      restart: {
        title: 'Dienst neu starten',
        monBody: 'Der MON-Daemon auf {node} wird über die Supervision des Workers gestoppt und neu gestartet.',
        mgrBody: 'Der MGR-Daemon auf {node} wird über die Supervision des Workers gestoppt und neu gestartet.',
        started: 'Neustart gestartet — die Beobachtung aktualisiert sich von selbst',
        error: 'Der Neustart wurde abgelehnt'
      },
      encryptionMode: {
        alwaysOn: 'Immer aktiviert (dmcrypt)',
        alwaysOff: 'Immer deaktiviert',
        perOsd: 'Pro OSD gewählt',
        section: 'OSD-Verschlüsselung at rest',
        title: 'OSD-Verschlüsselungsmodus ändern',
        hint: 'Wie NEUE OSDs vorbereitet werden. Bestehende OSDs behalten ihren Per-Disk-Zustand: zum Ändern wird der OSD entfernt und neu erstellt.',
        body: 'Der Modus wird "{mode}" und gilt NUR für NEUE OSDs: jeder bestehende OSD behält seinen aktuellen Verschlüsselungszustand.',
        apply: 'Modus ändern',
        error: 'Der Moduswechsel wurde abgelehnt'
      },
      pin: {
        address: 'Public-Adresse (optionaler Pin)',
        clusterAddress: 'Cluster-Adresse (optionaler Pin)',
        autoPlaceholder: 'automatisch in der Subnet {cidr}',
        hint: 'Adressierung pro Daemon: leer = Ceph bindet sich selbst innerhalb des deklarierten Netzwerks; gesetzt = diese Instanz wird an die Adresse in ihrer conf-Sektion gepinnt.'
      },
      addMon: {
        title: 'Knoten hinzufügen',
        node: 'Knoten',
        address: 'Public-Adresse',
        addressHint: 'Die Adressen des Knotens, die das IPAM innerhalb der Public-Subnet kennt — automatisch, wenn eine bestehende Deklaration den Knoten abdeckt.',
        clusterAddress: 'Cluster-Adresse',
        clusterAddressHint: 'Erforderlich: die Cluster-Subnet ist separat und der Knoten ist dort noch nicht deklariert.',
        noAddresses: 'Das IPAM kennt keine Adressen dieses Knotens innerhalb der Subnet',
        error: 'Das Hinzufügen des MON wurde abgelehnt'
      },
      removeMon: {
        title: 'MON entfernen',
        body: 'Der MON und sein kolokierter MGR verlassen den Knoten {node}. Auf einem deployten Cluster werden die Daemons gestoppt und aus dem Quorum entfernt.',
        error: 'Das Entfernen des MON wurde abgelehnt'
      },
      addMgr: {
        title: 'MGR hinzufügen',
        node: 'Knoten',
        hint: 'Erweitert (MON/MGR getrennt): ein Standalone-Manager entsteht auf dem gewählten Mitgliedsknoten durch einen knotenaffinen Task. Die Active/Standby-Wahl von Ceph bestimmt selbst den aktiven MGR.',
        error: 'Das Hinzufügen des MGR wurde abgelehnt'
      },
      removeMgr: {
        title: 'MGR entfernen',
        body: 'Der Standalone-MGR verlässt den Knoten {node}. Auf einem deployten Cluster wird der Daemon gestoppt und sein Zustand entfernt; der MON des Knotens (falls vorhanden) bleibt unberührt.',
        error: 'Das Entfernen des MGR wurde abgelehnt'
      },
      addMds: {
        title: 'MDS hinzufügen',
        node: 'Knoten',
        hint: 'Der Metadata-Server von CephFS: entsteht auf dem gewählten Mitgliedsknoten durch einen knotenaffinen Task, vom Worker supervisioniert wie MON und MGR. Ceph wählt Aktive und Standbys selbst — ein Aktiver plus ein Standby bedienen ein Filesystem gut.',
        error: 'Das Hinzufügen des MDS wurde abgelehnt'
      },
      removeMds: {
        title: 'MDS entfernen',
        body: 'Der MDS verlässt den Knoten {node}. Auf einem deployten Cluster wird der Daemon gestoppt und sein Zustand entfernt; die API lehnt den letzten MDS ab, solange ein Filesystem ihn braucht.',
        error: 'Das Entfernen des MDS wurde abgelehnt'
      },
      split: {
        title: 'MON/MGR getrennt',
        label: 'MON und MGR auf disjunkten Knoten erlauben',
        hint: 'Aus (Default) = der ratifizierte Standard: ein MGR läuft kolokiert mit jedem MON, eine einzige Membership. An = die Membership der MGRs wird eigenständig, verwaltet mit den Aktionen MGR hinzufügen/entfernen im Tab Verwaltungsknoten.',
        enable: 'Aktivieren',
        disable: 'Deaktivieren',
        enableBody: 'Die Membership der MGRs wird unabhängig von den MONs, initialisiert aus der aktuellen Kolokation. Die Aktionen MGR hinzufügen/entfernen werden im Tab Verwaltungsknoten scharf. Das lockert den Plattform-Default — behalten Sie es nur, wenn Sie wissen, warum Sie es brauchen.',
        disableBody: 'Zurück zur Standard-Kolokation: ein MGR mit jedem MON, eine einzige Membership. Nur zulässig, wenn die Membership der MGRs bereits mit den MONs zusammenfällt — gleichen Sie sie zuerst mit MGR hinzufügen/entfernen an, sonst lehnt die API ab.',
        error: 'Die Änderung wurde abgelehnt'
      },
      rawEditor: {
        title: 'Roher CRUSH-Editor',
        label: 'Den rohen Crushmap-Editor im Tab CRUSH anzeigen',
        hint: 'Aus (Default) = die geführte Regeloberfläche ist das Standardwerkzeug. An = der Tab CRUSH zeigt auch die dekompilierte Crushmap als editierbaren Text. Das Speichern verlangt immer sudo, den Clusternamen als Bestätigung, und durchläuft compile + test von crushtool, BEVOR es den Cluster erreicht.'
      },
      osdFlags: {
        section: 'Globale OSD-Flags',
        title: 'OSD-Flag-Override',
        notObserved: 'noch nicht beobachtet',
        standardFlowsHint: 'Die Standard-Flows der Plattform verwalten diese Flags in den normalen Fällen selbst (die Wartung eines Knotens setzt ein gezieltes noout, der Festplattentausch läuft über den OSD-Lebenszyklus). Diese Sektion ist der manuelle Override für den Operator, der weiß, was er tut.',
        notDeployedGuard: 'OSD-Flags existieren nur auf einem deployten Cluster',
        set: 'Flag setzen',
        unset: 'Flag entfernen',
        setBody: 'Das globale Flag {flag} wird auf der Osdmap GESETZT. Es bleibt, bis es explizit entfernt wird — ein vergessenes Flag degradiert die Selbstheilung des Clusters.',
        unsetBody: 'Das globale Flag {flag} wird von der Osdmap ENTFERNT.',
        error: 'Die Flag-Änderung wurde abgelehnt',
        flag: {
          noout: 'Kein OSD wird aus der Datenverteilung als out markiert — kein Rebalancing beim Verlust eines Daemons',
          norebalance: 'Das Rebalancing der Daten ist ausgesetzt',
          nobackfill: 'Der Backfill ist ausgesetzt',
          norecover: 'Das Recovery ist ausgesetzt',
          pause: 'DER GESAMTE Client-I/O ist pausiert (Lesen und Schreiben)',
          noin: 'Startende OSDs werden nicht automatisch als in markiert',
          nodown: 'Unerreichbare OSDs werden nicht als down markiert — maskiert echte Ausfälle'
        }
      },
      pools: {
        section: 'Pools',
        create: 'Pool erstellen',
        createGuard: 'Pools existieren nur auf einem deployten Cluster',
        notObserved: 'Keine Beobachtung der Pools — der Sweep des MON berichtet hier',
        empty: 'Kein Pool auf dem Cluster',
        colName: 'Name',
        colReplication: 'Size / min size',
        colPgNum: 'PGs',
        colApplication: 'Anwendung',
        colRule: 'CRUSH-Regel',
        colUsage: 'Nutzung',
        observedAtLabel: 'Beobachtet am',
        objects: '{n} Objekte',
        inUseBy: 'in Nutzung durch {name}',
        internalGuard: 'Ceph-interner Pool — die Plattform löscht ihn nie',
        delete: 'Pool löschen',
        deleteGuard: 'Vom Storage {name} konsumiert — löschen Sie zuerst den Storage',
        hint: 'Nur replizierte Pools (Erasure Coding außerhalb des Scopes v1). Die Replikation lebt in Ceph: diese Tabelle ist die beobachtete Wahrheit aus dem Sweep des MON.',
        createTitle: 'Pool erstellen',
        createHint: 'Der Pool entsteht auf dem Cluster mit der gewünschten Replikation und aktivierter rbd-Anwendung — die Arbeit erledigt ein Task auf einem MON-Knoten. Aktivieren Sie "Als Storage vorschlagen", um ihn sofort in derselben Geste zu konsumieren.',
        name: 'Pool-Name',
        nameHint: 'DNS-safe (Kleinbuchstaben, Ziffern, Bindestriche).',
        size: 'Replikate (size)',
        sizeHint: 'Kopien jedes Objekts. Default 3.',
        minSize: 'Minimale Replikate (min_size)',
        minSizeHint: 'Minimale Kopien, um I/O zu bedienen — folgt size − 1, bis Sie es ändern.',
        createError: 'Die Erstellung des Pools wurde abgelehnt',
        deleteTitle: 'Pool löschen',
        deleteBody: 'Der Pool {pool} und JEDES Objekt darin werden unwiderruflich zerstört. Geben Sie den Namen des Pools zur Bestätigung ein.',
        confirmLabel: 'Pool-Name',
        confirmHint: 'Geben Sie den Namen des Pools zur Bestätigung ein',
        deleteError: 'Das Löschen des Pools wurde abgelehnt',
        detailTitle: 'Pool-Details',
        autoscaler: 'PG Autoscaler',
        autoscalerOn: 'Aktiv',
        autoscalerOff: 'Nicht aktiv',
        autoscalerWarn: 'Benachrichtigen',
        pgNumLabel: 'Anzahl der PGs',
        pgNumCaption: 'Beobachtet: der Autoscaler kann ihn eigenständig ändern — dieses Feld schreibt einen Wunsch.',
        storage: 'Zugeordneter TVirt-Storage',
        addAsStorage: 'Als TVirt-Storage hinzufügen',
        ruleSudoHint: 'Das Ändern der CRUSH-Regel erfordert das Operator-Passwort.',
        updateError: 'Die Änderung des Pools wurde abgelehnt',
        updated: 'Pool-Änderung gestartet — die Beobachtung aktualisiert sich von selbst'
      },
      crush: {
        section: 'CRUSH-Regeln',
        notObserved: 'Noch keine CRUSH-Beobachtung — der Sweep des MON berichtet hier',
        empty: 'Keine Regel auf dem Cluster beobachtet',
        hint: 'Eine Regel entscheidet, WO die Kopien jedes Objekts landen — ihre Fehlerdomäne ist die Einheit, die ausfallen kann, ohne Daten zu verlieren. Pools zeigen auf eine Regel; die builtin replicated_rule (ein Replikat pro Server) ist der Geburts-Default.',
        create: 'Regel erstellen',
        createGuard: 'CRUSH-Regeln existieren nur auf einem deployten Cluster',
        createTitle: 'CRUSH-Regel erstellen',
        createHint: 'Eine Regel = eine Wahl der Fehlerdomäne. Die Regel entsteht repliziert auf dem Default-Root — die Arbeit erledigt ein Task auf einem MON-Knoten; ordnen Sie die Pools danach im Tab Pools zu.',
        createError: 'Die Erstellung der Regel wurde abgelehnt',
        name: 'Regelname',
        nameHint: 'DNS-safe (Kleinbuchstaben, Ziffern, Bindestriche).',
        domain: 'Fehlerdomäne',
        domainChoice: {
          osd: 'Jedes Replikat auf einem anderen OSD',
          host: 'Jedes Replikat auf einem anderen Server',
          rack: 'Jedes Replikat in einem anderen Rack'
        },
        domainCustom: 'Benutzerdefiniert (handgeschriebene Steps)',
        domainOther: 'Jedes Replikat in einem anderen {type}',
        rackGuardHint: 'Kein Rack-Bucket existiert in der beobachteten Hierarchie: die Regel lässt sich trotzdem erstellen, aber kein Pool kann auf sie zeigen, bis ein Rack in der Platzierung der Mitgliedsserver deklariert ist (Knoteneinstellungen) — der Neuausrichtungs-Task baut den Bucket und die Zuordnung öffnet sich von selbst.',
        treeTitle: 'Beobachtete Hierarchie',
        treeNotObserved: 'Keine Beobachtung der Hierarchie — der Sweep des MON berichtet hier',
        treeOsds: '{n} OSD',
        treeHint: 'Die CRUSH Map, wie der Cluster sie sieht: root → deklarierte Ebenen → Server (Hosts) → OSDs. Die Topologie folgt der deklarierten Platzierung jedes Servers (Knoteneinstellungen) — eine Positionsänderung richtet sie per Task neu aus.',
        unplacedWarning: 'Mitglieder ohne deklarierte Position: {nodes} — ihre Hosts bleiben direkt unter dem Root, außerhalb der deklarierten Topologie. Deklarieren Sie die Position in den Knoteneinstellungen (eine Warnung, nie eine Blockade).',
        colName: 'Name',
        colDomain: 'Fehlerdomäne',
        colPools: 'Pools',
        builtinChip: 'builtin',
        builtinGuard: 'Die Default-Regel des Clusters — die Plattform löscht sie nie',
        detailAction: 'Regeldetail',
        detailType: 'Typ',
        backToRules: 'Regeln',
        ruleNotObserved: 'Die beobachtete Regelliste nennt diese Regel nicht',
        noPools: 'Kein Pool nutzt diese Regel',
        delete: 'Regel löschen',
        deleteTitle: 'CRUSH-Regel löschen',
        deleteBody: 'Die Regel {rule} wird aus der Crushmap des Clusters entfernt. Kein Pool darf sie nutzen. Geben Sie den Namen der Regel zur Bestätigung ein.',
        deleteGuard: 'Vom Pool {name} genutzt — lassen Sie den Pool zuerst auf eine andere Regel zeigen',
        confirmLabel: 'Regelname',
        confirmHint: 'Geben Sie den Namen der Regel zur Bestätigung ein',
        deleteError: 'Das Löschen der Regel wurde abgelehnt',
        changeRule: 'CRUSH-Regel ändern',
        changeRuleTitle: 'CRUSH-Regel ändern',
        changeRuleHint: 'Der Pool beginnt, seine Objekte nach der gewählten Regel zu platzieren — Ceph verschiebt die bestehenden Daten, um sich anzupassen (auf einem vollen Pool folgt ein Rebalancing).',
        changeRuleError: 'Der Regelwechsel wurde abgelehnt',
        rule: 'CRUSH-Regel',
        rawTitle: 'Rohe Crushmap (dekompiliert)',
        rawWarning: 'GEFAHR: dieser Text ist die GESAMTE Platzierungspolitik des Clusters. Eine falsche Map kann das Placement aller Pools auf einmal brechen. Das Speichern kompiliert und testet die Map mit crushtool, BEVOR sie injiziert wird — aber eine gültige Map kann trotzdem eine schlechte Idee sein.',
        rawReload: 'Neu laden',
        rawLoading: 'Query läuft — ein Read-only-Task dekompiliert die Crushmap…',
        rawSave: 'Crushmap speichern',
        rawSaveTitle: 'Crushmap injizieren',
        rawSaveBody: 'Der bearbeitete Text ersetzt die Crushmap des GESAMTEN Clusters nach compile + test von crushtool. Geben Sie den Namen des Clusters zur Bestätigung ein.',
        rawConfirmLabel: 'Clustername',
        rawConfirmHint: 'Geben Sie {name} zur Bestätigung ein',
        rawError: 'Die Operation auf der Crushmap ist fehlgeschlagen',
        rawHint: 'Der Text ist die Form crushtool -d. Compile- und Testfehler kommen Wort für Wort von crushtool zurück — die Map erreicht den Cluster nicht, wenn eines der beiden Gates fehlschlägt.'
      },
      objects: {
        poolsSection: 'Objekt-Explorer',
        poolsHint: 'Wählen Sie einen Pool, um seine RBD-Images aufzulisten. Jede tiefe Lesung läuft als Read-only-Task auf einem MON-Knoten — sie blockiert nie die realen Operationen (und wird nicht von ihnen blockiert).',
        deployedGuard: 'Objekt-Queries antworten nur auf einem deployten Cluster',
        browse: 'Objekte durchstöbern',
        detailAction: 'Image-Detail',
        backToPools: 'Pools',
        backToImages: 'Images',
        refresh: 'Aktualisieren',
        loading: 'Query läuft — ein Read-only-Task befragt den Cluster…',
        error: 'Die Query ist fehlgeschlagen',
        retry: 'Erneut versuchen',
        notRbd: 'Pool mit Anwendung "{app}" — er enthält keine RBD-Images, hier gibt es nichts zu erkunden',
        noImages: 'Keine RBD-Images in diesem Pool',
        colImage: 'Image',
        colSize: 'Größe',
        colObjects: 'Objekte',
        colSnapshots: 'Snapshots',
        imagesHint: 'Die Festplatten auf einem konsumierenden rbd-Storage sind Images mit dem Namen ihrer Festplatten-ID. Die Objektzählung ist provisioned (Größe / Objektgröße) — die reale Nutzung lebt im Image-Detail.',
        infoTitle: 'Image',
        infoSize: 'Virtuelle Größe',
        infoObjects: 'Objekte (provisioned)',
        infoObjectSize: 'Objektgröße',
        infoPrefix: 'Objekt-Präfix',
        infoFormat: 'Format',
        infoFeatures: 'Features',
        usageTitle: 'Reale Nutzung (rbd du)',
        usageOf: 'von {provisioned} GiB provisioned',
        usageHint: 'Thin von Natur aus: nur geschriebene Objekte belegen Bytes.',
        watchersTitle: 'Watcher',
        noWatchers: 'Kein Watcher — niemand hat dieses Image gerade offen',
        snapshotsTitle: 'RBD-Snapshots',
        noSnapshots: 'Kein RBD-Snapshot auf diesem Image',
        colSnapshot: 'Snapshot',
        colProtected: 'Geschützt',
        colTimestamp: 'Erstellt',
        protected: 'geschützt',
        mappingTitle: 'Physische Zuordnung (OSD-Menge)',
        mappingSampled: 'Stichprobe von {sampled} Objekten von {total} — eine ehrliche Zusammenfassung: bei großen Images konvergiert die Menge gegen ALLE OSDs des Pools (CRUSH verteilt die Objekte über den ganzen Pool).',
        mappingComplete: 'Alle Objekte gemappt ({total} von {total}).',
        objectQueryTitle: 'Ein einzelnes Objekt mappen',
        objectName: 'Objektname',
        objectHint: 'RADOS-Objektnamen sind <Präfix>.<16-Hex-Index> — ceph osd map antwortet mit PG und OSD-Tripeln.',
        mapObject: 'Mappen',
        primary: 'primär: osd.{osd}'
      },
      registerDevice: {
        title: 'OSD-Gerät registrieren',
        hint: 'Auf einem lebenden Cluster BEREITET die Registrierung das Gerät auch VOR: es wird durch einen automatischen knotenaffinen Task zu einem BlueStore-OSD (nie leer, ratifiziert 2026-07-24). Ein Gerät gehört flottenweit zu höchstens einem Ceph-Cluster.',
        disk: 'Datenfestplatte',
        diskHint: 'Die deklarierten Datenfestplatten des Knotens — Name und Seriennummer',
        noDeclared: 'Keine Datenfestplatten auf diesem Knoten deklariert — markieren Sie sie zuerst in den lokalen Knoteneinstellungen',
        serialHint: 'Die Seriennummer des Geräts — der Identitäts-Pin',
        encrypted: 'Diesen OSD verschlüsseln (dmcrypt)',
        encryptedHint: 'Die Per-OSD-Wahl (der Cluster-Modus ist "pro OSD gewählt"): sie friert bei der Registrierung auf dieser Festplatte ein — ein späterer Moduswechsel überschreibt sie nie; das tut die Zeilenaktion Verschlüsseln/Entschlüsseln.',
        error: 'Die Registrierung wurde abgelehnt'
      },
      unregisterDevice: {
        title: 'Gerät deregistrieren',
        body: 'Nur Register: {name} hört auf, ein OSD-Kandidat dieses Clusters zu sein. Seine Bytes werden nicht angerührt.',
        error: 'Die Deregistrierung wurde abgelehnt'
      },
      deploy: {
        action: 'Deploy erneut versuchen',
        title: 'Bootstrap erneut versuchen',
        body: 'Der Geburts-Bootstrap startet erneut aus der aktuellen Konfiguration: die MONs starten, jedes registrierte Gerät wird als BlueStore-OSD vorbereitet und aktiviert. Die Operation läuft als Makrotask — die Phase aktualisiert sich von selbst.',
        started: 'Bootstrap gestartet — er läuft als Makrotask weiter; die Phase aktualisiert sich von selbst',
        error: 'Der Bootstrap wurde abgelehnt'
      },
      propose: {
        action: 'Als Storage vorschlagen',
        title: 'Als Storage vorschlagen',
        hintPool: 'Der bestehende Pool {name} wird ein TVirt-Storage: eine auf den Pool begrenzte cephx-Identität landet im Keystore und der ceph-rbd-Storage entsteht fertig. Der Vorschlag konsumiert den Pool — er erstellt nie einen.',
        hintFs: 'Das bestehende Filesystem {name} wird ein TVirt-Storage: eine auf das Filesystem begrenzte cephx-Identität landet im Keystore und der cephfs-Storage entsteht fertig und gemountet. Der Vorschlag konsumiert das Filesystem — er erstellt nie eines.',
        name: 'Storage-Name',
        nameHint: 'DNS-1123, eindeutig im Scope — die cephx-Identität ist nach ihm benannt.',
        path: 'Path innerhalb des Filesystems',
        pathHint: 'Absoluter Path innerhalb des Filesystems, das der Storage mountet — / im Zweifel.',
        alsoPropose: 'Sofort als Storage vorschlagen',
        alsoProposePoolHint: 'Nach der Erstellung schlägt dieselbe Geste den neugeborenen Pool als ceph-rbd-Storage vor — zwei explizite Aufrufe, ein einziger Dialog.',
        alsoProposeFsHint: 'Nach der Erstellung schlägt dieselbe Geste das neugeborene Filesystem als cephfs-Storage vor — zwei explizite Aufrufe, ein einziger Dialog.',
        guard: 'Als Storage vorschlagen — nur auf einem healthy Cluster',
        started: 'Vorschlag angenommen — der Storage materialisiert sich; Sie finden ihn unter Storage',
        submit: 'Storage erstellen',
        error: 'Der Vorschlag wurde abgelehnt'
      },
      fs: {
        section: 'Filesysteme',
        create: 'Filesystem erstellen',
        createGuard: 'Filesysteme existieren nur auf einem deployten Cluster',
        mdsFirstGuard: 'Fügen Sie zuerst einen MDS hinzu — ein Filesystem ohne Metadata-Server wird unbrauchbar geboren',
        notObserved: 'Keine Beobachtung der Filesysteme — der Sweep des MON berichtet hier',
        empty: 'Kein Filesystem auf dem Cluster',
        colName: 'Name',
        colPools: 'Pools',
        colMds: 'MDS',
        noActiveMds: 'kein aktiver MDS',
        delete: 'Filesystem entfernen',
        deleteGuard: 'Vom Storage {name} konsumiert — löschen Sie zuerst den Storage',
        hint: 'Ein Filesystem besitzt seine Daten- und Metadata-Pools (cephfs.<name>.data / .meta): sie entstehen mit ihm und sterben mit ihm — removeFs, nie ein manuelles Pool-Delete. Diese Tabelle ist die beobachtete Wahrheit aus dem Sweep des MON.',
        createTitle: 'Filesystem erstellen',
        createHint: 'Das Filesystem entsteht auf dem Cluster mit seinen zwei Pools (Anwendung cephfs) und wird von den deklarierten MDS bedient — die Arbeit erledigt ein Task auf einem MON-Knoten. Aktivieren Sie "Als Storage vorschlagen", um es sofort in derselben Geste zu konsumieren.',
        name: 'Filesystem-Name',
        nameHint: 'DNS-safe (Kleinbuchstaben, Ziffern, Bindestriche).',
        sizeHint: 'Replikate BEIDER neugeborener Pools. Default 3.',
        createError: 'Die Erstellung des Filesystems wurde abgelehnt',
        deleteTitle: 'Filesystem entfernen',
        deleteBody: 'Das Filesystem {fs} und JEDE Datei darin werden unwiderruflich zerstört — seine Daten- und Metadata-Pools sterben mit ihm. Geben Sie den Namen des Filesystems zur Bestätigung ein.',
        confirmLabel: 'Filesystem-Name',
        confirmHint: 'Geben Sie den Namen des Filesystems zur Bestätigung ein',
        deleteError: 'Das Entfernen des Filesystems wurde abgelehnt'
      },
      destroy: {
        action: 'Zerstören',
        retryAction: 'Beseitigung erneut versuchen',
        retryGuard: 'Die Zerstörung läuft — der Retry gilt für eine fehlgeschlagene Zerstörung (sonst lehnt der Lease ab)',
        title: 'Den Cluster zerstören',
        body: 'Die deployte Fabric wird abgebaut: jeder Daemon dieses Clusters stoppt, sein Systemzustand und die Schlüssel im Keystore werden freigegeben. Nach erfolgreicher Zerstörung wird der Cluster automatisch entfernt.',
        confirmLabel: 'Clustername',
        confirmHint: 'Geben Sie den Namen des Clusters zur Bestätigung ein',
        wipe: 'Die registrierten Geräte löschen',
        wipeHint: 'Angehakt: die Signaturen jedes registrierten Geräts werden gelöscht — die Daten darauf sind zerstört. Nicht angehakt: die Bytes bleiben intakt und die Geräte kehren zu registriert zurück.',
        guard: 'Zerstören — nichts deployt',
        started: 'Zerstörung gestartet — sie läuft als Makrotask weiter; die Phase aktualisiert sich von selbst',
        error: 'Die Zerstörung wurde abgelehnt'
      },
      delete: {
        guard: 'Löschen — nur eine nicht deployte Konfiguration (zuerst zerstören)',
        title: '{name} löschen?',
        body: 'Die Konfiguration und ihr Geräteregister werden entfernt. Nur zulässig, solange nichts deployt ist.',
        error: 'Das Löschen wurde abgelehnt'
      }
    }
  }
}
